const topics = [
  {
    icon: 'ri-alert-line',
    title: '明星塌房实录',
    desc: '当红艺人翻车事件全记录，从爆料到实锤完整追踪',
    count: '126篇',
    color: 'text-primary-600',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-tv-line',
    title: '综艺争议全记录',
    desc: '热门综艺节目争议片段逐帧还原与深度解析',
    count: '98篇',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
  {
    icon: 'ri-user-smile-line',
    title: '网红翻车合集',
    desc: '网络红人虚假人设崩塌事件持续追踪报道',
    count: '87篇',
    color: 'text-secondary-600',
    bg: 'bg-secondary-100',
  },
  {
    icon: 'ri-spy-line',
    title: '娱乐圈内幕爆料',
    desc: '圈内人士独家透露的行业潜规则与幕后故事',
    count: '64篇',
    color: 'text-primary-600',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-music-line',
    title: '选秀黑料整理',
    desc: '各类选秀节目选手背景扒皮与争议事件汇总',
    count: '53篇',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
  {
    icon: 'ri-shopping-bag-line',
    title: '直播带货争议',
    desc: '头部主播产品翻车与虚假宣传事件全记录',
    count: '72篇',
    color: 'text-secondary-600',
    bg: 'bg-secondary-100',
  },
  {
    icon: 'ri-film-line',
    title: '影视剧吐槽大会',
    desc: '热播剧集争议剧情与幕后制作混乱大起底',
    count: '105篇',
    color: 'text-primary-600',
    bg: 'bg-primary-100',
  },
  {
    icon: 'ri-fire-line',
    title: '饭圈撕逼大赏',
    desc: '粉丝群体之间的激烈交锋与饭圈名场面',
    count: '141篇',
    color: 'text-accent-600',
    bg: 'bg-accent-100',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门专题</h2>
          <p className="text-sm text-foreground-500">按分类浏览你最感兴趣的吃瓜内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className={`${t.bg} rounded-lg p-4 md:p-5 transition-all duration-200 hover:scale-[1.03] cursor-pointer group`}
            >
              <div className={`w-10 h-10 md:w-11 md:h-11 rounded-lg ${t.bg} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${t.icon} ${t.color} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">{t.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{t.desc}</p>
              <span className={`text-xs font-medium ${t.color}`}>{t.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}